import { Skeleton } from '../skeleton';

/**
 * 統計カードのスケルトンUI
 */
export function StatsCardSkeleton() {
  return (
    <div className="gap-md grid grid-cols-3 p-lg">
      {Array.from({ length: 3 }).map((_, index) => (
        <div key={index} className="space-y-sm rounded-lg border p-md">
          <Skeleton className="h-5 w-20" />
          <Skeleton className="h-8 w-16" />
        </div>
      ))}
    </div>
  );
}
